import { Module } from "vuex";
import Vue from "vue";
import { MethodService } from "@/utils/serviceModel";

const req: IRequestInfo = {
  moduleName: "plat.table",
  className: "TableManager",
  method: "getSource",
  args: {}
};

const dbModule: Module<ITableSetState, any> = {
  namespaced: true,
  state: {
    currentId: "",
    currentColumnChangedId: "",
    tables: {},
    columnsSource: {}
  },
  getters: {
    table: (state: ITableSetState) => id => {
      if (!state.tables[id]) {
        let s = {
          Id: id,
          loading: false,
          headers: [],
          props: []
        };
        Vue.set(state.tables, id, s);
      }
      return state.tables[id];
    },
    column: (state: ITableSetState) => id => {
      if (!state.columnsSource[id]) {
        state.columnsSource[id] = {
          Id: id,
          loading: false,
          dataSource: []
        };
      }
      return state.columnsSource[id];
    }
  },
  mutations: {
    setTable(state: ITableSetState, table: ITableState) {
      let id = table.Id;
      state.tables = { ...state.tables, [id]: table };
    },

    setCurrentId(state, id) {
      // Vue.set(state, "currentId", id);
      state.currentId = id;
    },

    setColumnId(state, id) {
      state.currentColumnChangedId = id;
    },

    setSource(state: ITableSetState, column: IColumnSourceState) {
      let id = column.Id;
      state.currentColumnChangedId = id;
      state.columnsSource = { ...state.columnsSource, [id]: column };
    },
    setColumnVisibility(state: ITableSetState, args: IndexObject) {
      let tableId: string = args.tableId;
      let colId: string = args.colId;
      let visibility: boolean = args.visibility;
      if (state.tables[tableId]) {
        let headers = state.tables[tableId].headers;
        if (headers) {
          let index = headers.findIndex((h: IndexObject) => h.Id === colId);
          if (index >= 0) {
            headers[index].hide = visibility;
          }
        }
      }
    }
  },
  actions: {
    async fetchTableData({ commit, rootState }, para: ITableLayoutArgs) {
      let method = new MethodService(
        req.moduleName,
        req.className,
        "getTableConfig"
      );
      let loginer = rootState.loginer as ILoginer;
      let args = {
        tableId: "",
        user: loginer.name,
        ["db"]: "",
        ["table"]: ""
      };
      if (para) {
        if (typeof para === "string") {
          args.tableId = para as string;
        } else {
          args.tableId = para.Id as string;
          args.db = para.db as string;
          args.table = para.table as string;
        }
        await method.invokeAsyn(args);
        if (method.isSuccess && method.data) {
          let data = method.data as IndexObject;
          let ls: ITableState = {
            Id: data[0],
            headers: data[1].headers,
            props: data[1].props
          };
          // console.log(ls);
          commit("setTable", ls);
          commit("setCurrentId", ls.Id);
          return ls.Id;
        }
      }
    },

    async fetchColumnSource({ commit, rootState }, id) {
      let method = new MethodService(req.moduleName, req.className, req.method);
      let enterprise = rootState.loginer.Site
        ? rootState.loginer.Site.Id
        : null;
      let args = { columnId: id, enterprise };
      let ls: IColumnSourceState = {
        Id: id,
        loading: true
      };
      commit("setSource", ls);
      await method.invokeAsyn(args);
      ls.loading = false;
      if (method.isSuccess) {
        ls.dataSource = method.data;
      }
      commit("setSource", ls);
      commit("setColumnId", id);
    }
  }
};

export default dbModule;
